import { cva, type VariantProps } from 'class-variance-authority';

import { mergeClasses } from '../../utils/merge-classes';

export const optionSliderVariants = cva(
  mergeClasses('flex flex-col gap-2 w-full'),
  {
    variants: {
      variant: {
        stops: '',
        end: '',
      },
    },
    defaultVariants: {
      variant: 'stops',
    },
  },
);

export const optionSliderDotVariants = cva(
  mergeClasses(
    'absolute top-1/2 size-1 -translate-y-1/2 rounded-full pointer-events-none',
  ),
  {
    variants: {
      tone: {
        active: 'bg-primary-container',
        inactive: 'bg-primary',
      },
    },
    defaultVariants: {
      tone: 'inactive',
    },
  },
);

export type OptionSliderVariant = NonNullable<VariantProps<typeof optionSliderVariants>['variant']>;
